import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightTitle: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.your-project.spotlight-title',
		defaultMessage: 'Here’s the project you created',
		description: `Title text
            - for a spotlight that highlights the user's first created project card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightBody: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.your-project.spotlight-body',
		defaultMessage:
			'Your service project is ready to use. Select it to jump in and start exploring.',
		description: `Body text
            - for a spotlight that highlights the user's first created project card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightNextButton: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.your-project.spotlight-next-button',
		defaultMessage: 'Next',
		description: `Button text that will go to the next spotlight in the tour
            - for a spotlight that highlights the user's first created project card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
	spotlightOkButton: {
		id: 'servicedesk-itsm-first-session-flow.your-work-tour.spotlight-tour.your-project.spotlight-ok-button',
		defaultMessage: 'Ok',
		description: `Button text that will finish the spotlight tour
            - for a spotlight that highlights the "Demo Project" card
            - part of an onboarding tour in the 'Your Work' page, for 1st time users of JSM`,
	},
});
